import { LogIn } from 'lucide-react';

export default function LoginView({ onLogin, authError }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        padding: 24,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          background: 'var(--card-bg)',
          border: '1px solid var(--glass-border)',
          borderRadius: 'var(--radius-md)',
          padding: 32,
          boxShadow: 'var(--shadow-card)',
          textAlign: 'center',
        }}
      >
        <img
          src="/synolog-logo-vertical.svg"
          alt="Synolog"
          style={{
            width: 200,
            marginBottom: 24,
            background: '#fff',
            borderRadius: 'var(--radius-sm)',
            padding: 12,
          }}
        />
        <h1
          style={{
            margin: '0 0 8px',
            fontSize: 22,
            color: 'var(--text)',
          }}
        >
          synolog
        </h1>
        <p
          style={{
            margin: '0 0 24px',
            color: 'var(--text-muted)',
            fontSize: 14,
          }}
        >
          Schedule &amp; Logtime
        </p>

        {authError ? (
          <div
            role="alert"
            style={{
              background: 'rgba(239, 68, 68, 0.12)',
              border: '1px solid var(--danger)',
              color: 'var(--danger)',
              padding: '10px 14px',
              borderRadius: 'var(--radius-sm)',
              marginBottom: 16,
              fontSize: 13,
              textAlign: 'left',
            }}
          >
            {authError}
          </div>
        ) : null}

        <button
          type="button"
          onClick={() => onLogin()}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            background: 'var(--accent)',
            color: '#fff',
            border: 'none',
            borderRadius: 'var(--radius-sm)',
            padding: '12px 20px',
            fontSize: 15,
            fontWeight: 600,
          }}
        >
          <LogIn size={18} />
          Se connecter avec Google
        </button>

        <p
          style={{
            margin: '20px 0 0',
            fontSize: 12,
            color: 'var(--text-muted)',
          }}
        >
          Accès réservé aux comptes synotis.ch / synotis.com
        </p>
      </div>
    </div>
  );
}
